import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Signuptogetstarted from "../Signuptogetstarted";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import { loginWithPassword } from "../../../../redux/zservices/BasicAPIFunctions";
import { useNavigate } from "react-router-dom";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";
import { useDispatch } from "react-redux";
import { getProfile } from "../../../../redux/profile/action";
import ButtonLoader from "../../../Common/Loader/ButtonLoader";
import LoginLoaderButton from "../../../Common/Loader/LoginLoaderButton";
import { disabledStyle } from "../../../Common/ClickDisable";
import { notallowspace } from "../../../Common/FewCommonMethods";
import { emailvalidation, passwordvalidation } from "../../../Common/commonvalidation";
import AsteriskLabel from "../../../Common/AsteriskLabel";

const validationSchema = Yup.object().shape({
  // email_id: Yup.string().email('Invalid email_id').required('Email is required'),
  email_id: emailvalidation,
  password: passwordvalidation
  // Yup.string()
  //   .required("Password is required")
  //   .min(8, "Password must be at least 8 characters"),
});

export default function LoginwithEmail() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const navigate = useNavigate();
  const path = "Assets/scss/FirstTimeUsers.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const initialValues = {
    email_id: "",
    password: "",
  };

  const handleSubmit = async (values) => {
    setLoading(true);

    const data = {
      country_code: "",
      mobile_number: (values.email_id || "").trim(),
      password: values?.password,
    };

    try {
      const res = await loginWithPassword(data);
      await new Promise((resolve) => setTimeout(resolve, 2000));

      if (res?.data?.status) {
        localStorage.setItem("urexperttoken", res?.data?.response?.token);
        localStorage.setItem("role_type", res?.data?.response?.role_type);
        localStorage.setItem("refresh_token", res?.data?.response?.refresh_token);
        dispatch(getProfile());
        navigate(`/${lan}/account`);
        urtoast(res?.data?.response?.message, 1);
        // window.location.reload()
      } else {
        urtoast(res?.data?.response?.message, 2);
      }
    } catch (e) {
      urtoast(e?.message, 2);
      console.log(e, "the error")
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto register ">
      <h1 className="heading">Login account.</h1>

      <Signuptogetstarted />
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ errors, touched }) => (
          <Form>
            <div className="col-md-8 mx-auto form-sec login-email">
              <div className="row">
                <div className="col-md-12 form-group">
                  {/* <label htmlFor="email_id">Email or Mobile No.</label> */}
                  <label htmlFor="email_id">Email <AsteriskLabel /></label>
                  {/* <Field type="email_id" id="email_id" name="email_id" className='form-control' placeholder='Enter Email or Mobile No.' /> */}
                  <Field
                    type="email_id"
                    id="email_id"
                    name="email_id"
                    className="form-control"
                    placeholder="Enter Email"
                  />
                  <ErrorMessage
                    name="email_id"
                    component="div"
                    className="error"
                  />
                </div>

                <div className="col-md-12 form-group">
                  <label htmlFor="password">Password <AsteriskLabel /></label>
                  <div className="password-btn">
                    <Field
                      onKeyDown={notallowspace}
                      type={showPassword ? "text" : "password"}
                      id="password"
                      name="password"
                      className="form-control"
                      placeholder="Enter password"
                    />
                    <span onClick={togglePasswordVisibility} className="btn">
                      {showPassword ? (
                        <i className="fa-solid fa-eye" aria-hidden="true"></i>
                      ) : (
                        <i className="fa-solid fa-eye-slash"></i>
                      )}
                    </span>
                  </div>
                  <ErrorMessage
                    name="password"
                    component="div"
                    className="error"
                  />
                  <a
                    style={loading ? disabledStyle : {}}
                    onClick={() => navigate(`/${lan}/forgetpassword`)}
                    className="forgot-password"
                  >
                    Forgot password?
                  </a>
                </div>

                <div className="col-md-12 last-form">
                  <button disabled={loading} className="btn create-account">
                    {loading ? <LoginLoaderButton /> : "Login account"}
                  </button>
                  <a
                    style={loading ? disabledStyle : {}}
                    onClick={() => navigate(`/${lan}/loginwithmobile`)}
                    className="login-password"
                  >
                    Login with mobile number
                  </a>
                  <p>
                    Don’t have an account?  {' '}
                    <a
                      style={loading ? disabledStyle : {}}
                      onClick={() => navigate(`/${lan}/signup`)}
                    >
                      Sign up
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
